import { render } from "./VideoAnimationSelectorPage.vue?vue&type=template&id=4a9b8c88&scoped=true"
import script from "./VideoAnimationSelectorPage.vue?vue&type=script&lang=js"
export * from "./VideoAnimationSelectorPage.vue?vue&type=script&lang=js"

import "./VideoAnimationSelectorPage.vue?vue&type=style&index=0&id=4a9b8c88&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9b8c88"]])

export default __exports__